var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M0,4H4V0H0ZM6,16h4V12H6ZM0,16H4V12H0Zm0-6H4V6H0Zm6,0h4V6H6ZM12,0V4h4V0ZM6,4h4V0H6Zm6,6h4V6H12Zm0,6h4V12H12Z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }